import { Button, Pagination, Select, Table } from 'antd';
import React from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';



const columns = [
  {
    title: 'Expense Date',
    dataIndex: 'expense_date',
    key: 'expense_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.expense_date).toDateString()}</span>
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '40%'
  },
  {
    title: 'Employee',
    dataIndex: 'employee',
    key: 'employee',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // width: '20%'
  },
  {
    title: 'Paid By',
    dataIndex: 'paid_by',
    key: 'paid_by',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '10%'
  },
  {
    title: 'Total',
    dataIndex: 'total_amount',
    key: 'total_amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '5%',
    render: (_, record) => <span>{record.total_amount.$numberDecimal}</span>

  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '5%'
  },
  {
    title: 'Action',
    key: 'operation',
    // width: '20%',
    fixed: 'right',
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/expense/expenses/'+record.seo}>
        EDIT
      </Link>
    )
  }
]




const ExpenseReports = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/expense/reports/'+record.seo)
    };
  };


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Expense Reports</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/expense/reports/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination total={50} />
          </div>
        </div>
      </div>
      <Table
        key={'name'}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={loader}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default ExpenseReports;